
































import { Component, Vue, Prop } from 'vue-property-decorator'
import { CommonModule } from '../store'

@Component({
  name: 'CheckStrictlyChooseOrganationIds',
  components: {
    'my-dialog': () => import('./common/myDialog.vue')
  }
})
export default class CheckStrictlyChooseOrganationIds extends Vue {
  @Prop({ default: false }) public dialogVisibleBindOrganizationId: boolean
  @Prop({ default: [] }) public setCheckedNodesList: any[]
  @Prop({ default: '' }) public userId!: string | number
  @Prop({ default: '' }) public chooseOrganizationIdTitle: ''
  public defaultProps: any = {
    children: 'children',
    label: 'name'
  }
  public loading: boolean = true
  public isCheckAll: boolean = false

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  dialogOpen (setCheckedNodesList) {
    ;(this as any).$refs.bindOrganizationIdTree.setCheckedNodes(setCheckedNodesList)
    setTimeout(() => {
      this.loading = false
    }, 100)
  }

  // 给树形降维：
  flatteningForTree (tree) {
    // 把树形转换成一维的，为了全选：递归是因为目前父子不做关联
    let res = []
    let flattening = arr => {
      arr.some(item => {
        if (item.children && item.children.length > 0) {
          flattening(item.children)
        }
        res.push(item)
      })
    }
    flattening(tree)
    return res
  }

  /**
   * 共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点本身是否被选中、节点的子树中是否有被选中的节点
   * @param 传递给 data 属性的数组中该节点所对应的对象
   * @param 节点本身是否被选中
   * @param 节点的子树中是否有被选中的节点
   */
  checkChange () {
    let res = this.flatteningForTree(this.treeDataForSubOrganatizion)
    const BindOrganizationIds = (this as any).$refs.bindOrganizationIdTree.getCheckedNodes(
      false
    )
    if (BindOrganizationIds.length === res.length) {
      this.isCheckAll = true
    } else {
      this.isCheckAll = false
    }
  }

  // 保存：
  async saveBindOrganizationId () {
    try {
      let _that: any = this
      this.loading = true
      const BindOrganizationIds = (this as any).$refs.bindOrganizationIdTree.getCheckedNodes(
        false
      )
      let params = BindOrganizationIds.map(item => {
        return {
          organizationId: item.id,
          userId: this.userId
        }
      })
      let { data: result } = await _that.$http.sysUserSaveUserOrganization(
        params
      )
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('调整用户能访问的节点成功')
      this.$emit('update:dialogVisibleBindOrganizationId', false)
      this.$emit('getTableDataList')
    } catch (err) {
      console.log(err)
    }
  }

  async created () {
    await CommonModule.getTreeDataForSubOrganization()
  }

  chooseOfAll () {
    let res = this.flatteningForTree(this.treeDataForSubOrganatizion)
    const BindOrganizationIds = (this as any).$refs.bindOrganizationIdTree.getCheckedNodes(
      false
    )
    if (BindOrganizationIds.length === res.length) {
      ;(this as any).$refs.bindOrganizationIdTree.setCheckedNodes([])
      this.isCheckAll = false
    } else {
      ;(this as any).$refs.bindOrganizationIdTree.setCheckedNodes(res)
      this.isCheckAll = true
    }
  }
}
